import { render } from "./GiftCardEditor.vue?vue&type=template&id=43520a3a"
import script from "./GiftCardEditor.vue?vue&type=script&lang=js"
export * from "./GiftCardEditor.vue?vue&type=script&lang=js"

import "./GiftCardEditor.vue?vue&type=style&index=0&id=43520a3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__